import { resetInactivityTimer } from "~/Services/AdminSession";
import { useOptionsContext } from "~/Contexts/OptionsContext";

interface damImage {
    alt?: unknown;
    guid: string;
    height: number;
    title: string;
    type: string;
    url: string;
    width: number;
}

let currentOnFileSelected = (url: string) => {};
let optiDamUrl = "";

const fileSelected = (event: any) => {
    if (event.origin !== optiDamUrl || !Array.isArray(event.data)) {
        return;
    }
    const selectedImage = event.data[0] as damImage;
    currentOnFileSelected(selectedImage.url);
};

window.addEventListener("message", fileSelected, false);

export const useFileBrowser = (onFileSelected: (url: string) => void) => {
    const { optiDam } = useOptionsContext();
    optiDamUrl = optiDam.url;

    if (optiDam.isEnabled) {
        return {
            openFileBrowser: () => {
                currentOnFileSelected = onFileSelected;

                const options = {
                    organization: optiDam.organizationId,
                };

                const encodedOptions = window.btoa(JSON.stringify(options));

                window.open(`${optiDam.url}/cloud/library-picker?pickerOptions=${encodedOptions}`, "Library", "popup");
            },
        };
    }

    return {
        openFileBrowser: () => {
            (window as any).CKFinder.popup({
                chooseFiles: true,
                resizeImages: false,
                resourceType: "UserFiles",
                onInit(finder: any) {
                    finder.on("files:choose", (event: any) => {
                        onFileSelected(event.data.files.first().getUrl());
                    });
                    finder.on("command:before", (_: any) => {
                        resetInactivityTimer();
                    });
                },
                plugins: ["SearchFolder"],
            });
        },
    };
};
